import { GridHeaderCellProps } from '@progress/kendo-react-grid';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { InvoiceContext } from 'src/sections/invoice_details/InvoiceDetailsContext';
import { useContextSelector } from 'use-context-selector';
import PopUpContentWrapper from '../PopUpContentWrapper';
import PopUp from '../design-system/PopUp';
import ExpandCollapseCell from './ExpandCollapseCell';

const GLCodeDetailHeaderCell = (props: GridHeaderCellProps) => {
  const hasGLChanged = useContextSelector(InvoiceContext, (value) => value.hasGLChanged);
  const expandedGLCode = useContextSelector(InvoiceContext, (value) => value.expandedGLCode);
  const setExpandedGLCode = useContextSelector(InvoiceContext, (value) => value.setExpandedGLCode);
  const glBreakouts = useContextSelector(InvoiceContext, (value) => value.invoice.glBreakouts);
  const invoiceGlCodes = useContextSelector(InvoiceContext, (value) => value.invoiceGlCodes);

  const expandedGlCodeIds = glBreakouts?.map((el) => el.glCode);

  const [timeoutId, setTimeoutId] = useState<NodeJS.Timeout | null>(null);
  const [value, setValue] = useState(false);
  const isAllItemsExpanded = useMemo(
    () => invoiceGlCodes.some((gl) => expandedGLCode.includes(gl.glCode as string)),
    [invoiceGlCodes, expandedGLCode]
  );
  useEffect(() => {
    setValue(isAllItemsExpanded);
  }, [isAllItemsExpanded]);

  const handleHeaderCellExpand = useCallback(() => {
    if (!hasGLChanged) {
      const newValue = !value;
      setValue(newValue);

      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      const newTimeoutId = setTimeout(() => {
        setExpandedGLCode((prev) => (prev.length > 0 ? [] : expandedGlCodeIds));
      }, 500);
      setTimeoutId(newTimeoutId);
    }
  }, [expandedGlCodeIds, hasGLChanged, setExpandedGLCode, timeoutId, value]);

  return (
    <th className="k-header k-hierarchy-cell" style={{ borderBottomWidth: '0px' }}>
      <PopUp
        content={<PopUpContentWrapper type="Error" contents={['Save required']} />}
        show={hasGLChanged}
      >
        <ExpandCollapseCell
          expand={value}
          onExpand={handleHeaderCellExpand}
          title={hasGLChanged ? '' : 'Expand/Collapse All'}
          plusIconColor={hasGLChanged ? '#aaa' : '#fff'}
          minusIconColor={hasGLChanged ? '#aaa' : '#fff'}
        />
      </PopUp>
    </th>
  );
};

export default GLCodeDetailHeaderCell;
